import ContactPerson from '../ContactPerson/ContactPerson';
import Container from '../Container/Container';
import {
  HeadlineColor,
  HeadlineLevel,
  HeadlineAlign,
} from '../Headline/consts';
import Headline from '../Headline/Headline';
import Section from '../Section/Section';
import TwoColumnContainer from '../TwoColumnContainer/TwoColumnContainer';
import type { JobContactSectionProps } from './interfaces';
import styles from './JobContactSection.module.scss';

const JobContactSection = ({
  headline,
  subText,
  contactPerson,
}: JobContactSectionProps) => {
  return (
    <Section className={styles.sectionSpacer}>
      <Container>
        <TwoColumnContainer
          leftSideWidth={50}
          className={styles.questionContainer}
          contents-left={
            <Headline
              headlineColor={HeadlineColor.Gradient}
              level={HeadlineLevel.Two}
              subText={subText}
              align={HeadlineAlign.Left}
              spacing="large"
              className={styles.jobsHeadline}
            >
              {headline}
            </Headline>
          }
          contents-right={
            <ContactPerson
              image={contactPerson.profileImage}
              name={contactPerson.firstName + ' ' + contactPerson.lastName}
              jobTitle={contactPerson.jobTitle}
              mail={contactPerson.email}
              phone={contactPerson.phone}
              socials={contactPerson.socials}
              pronouns={contactPerson.pronouns}
            />
          }
        />
      </Container>
    </Section>
  );
};

export default JobContactSection;
